import { DeepReadonly } from 'utility-types';
import { InstitutionSummary } from '../../../ReduxStorage/Institutions/types';
import { ReduxAction } from '../../../ReduxStorage/actions';
import { CourseTileData } from '../../components/CourseTile/types';

export const FETCH_HOME_PAGE_DATA_SUCCESS = 'FETCH_HOME_PAGE_DATA_SUCCESS';

export type FetchHomePageDataSuccessAction = {
  type: 'FETCH_HOME_PAGE_DATA_SUCCESS';
  featuredCourses: CourseTileData[];
  featuredPartners: InstitutionSummary[];
};

export type HomePageAction = FetchHomePageDataSuccessAction;

export type HomePageState = DeepReadonly<{
  featuredCourses: DeepReadonly<CourseTileData[]>;
  featuredPartners: DeepReadonly<string[]>;
}>;

export const INITIAL_STATE: HomePageState = {
  featuredCourses: [],
  featuredPartners: [],
};

export const HomePageReducer = (
  state: HomePageState = INITIAL_STATE,
  action: ReduxAction
): HomePageState => {
  switch (action.type) {
    case FETCH_HOME_PAGE_DATA_SUCCESS: {
      const { featuredCourses, featuredPartners } = action;

      return {
        ...state,
        featuredCourses,
        featuredPartners: featuredPartners.map((partner) => partner.path),
      };
    }
    default:
      return state;
  }
};
